import { RegisterRedirect } from './RegisterRedirect';

document.addEventListener('DOMContentLoaded', function () {
  window.Webflow ||= [];

  window.Webflow.push(async () => {
    const app = new RegisterRedirect();
    app.init();
    document.documentElement.classList.add('webflow-loaded');
  });
});
